"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_helmet_1 = __importDefault(require("react-helmet"));
const ContentHeader_1 = __importDefault(require("@Components/ContentHeader"));
const SongwriterCatalogBuilderResults_1 = __importDefault(require("@Scenes/SongwriterScene/SongwriterCatalogBuilderScene/SongwriterCatalogBuilderResults"));
const contexts_1 = require("@App/contexts");
const SongwriterMyWritersHeader_1 = __importDefault(require("@Scenes/SongwriterScene/SongwriterMyWritersScene/SongwriterMyWritersHeader"));
const SongwriterMyWritersTable_1 = __importDefault(require("@Scenes/SongwriterScene/SongwriterMyWritersScene/SongwriterMyWritersTable"));
const mobx_react_1 = require("mobx-react");
const SearchByParty_1 = __importDefault(require("@Components/SearchByParty"));
const SongwriterMyWritersScene = () => {
    const { songwriterMyWriterSearchStore, preloaderStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    (0, react_1.useEffect)(() => {
        preloaderStore.openTransparentPreloader(true);
        songwriterMyWriterSearchStore.searchForParties().finally(() => preloaderStore.openTransparentPreloader(false));
        return () => {
            songwriterMyWriterSearchStore.resetStore();
        };
    }, []);
    const onWriterToggle = react_1.default.useCallback((isLinked, writerIpId) => __awaiter(void 0, void 0, void 0, function* () {
        yield songwriterMyWriterSearchStore.toggleSongwriterLink(isLinked, writerIpId);
    }), [songwriterMyWriterSearchStore]);
    const linkedWriterIpIdSet = react_1.default.useMemo(() => new Set(songwriterMyWriterSearchStore.linkedSongwriters.map((writer) => writer.affWriterIpId)), [songwriterMyWriterSearchStore.linkedSongwriters.length]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_helmet_1.default, { title: 'My Writer Names' }),
        react_1.default.createElement("div", { className: "songwriter-link-wrapper" },
            react_1.default.createElement(ContentHeader_1.default, { title: 'My Writer Names', content: react_1.default.createElement(SongwriterMyWritersHeader_1.default, null) }),
            react_1.default.createElement("div", { className: "songwriter-writer-search" },
                react_1.default.createElement(SearchByParty_1.default, { searchPartyStore: songwriterMyWriterSearchStore, renderPartyResultsTable: (onTitleClick, setLoading) => (react_1.default.createElement(SongwriterCatalogBuilderResults_1.default, { setLoading: setLoading, songwriterWriterSearchStore: songwriterMyWriterSearchStore },
                        react_1.default.createElement(SongwriterMyWritersTable_1.default, { data: songwriterMyWriterSearchStore.searchResultPartyDetails, onTitleClick: onTitleClick, linkedWriterIpIds: linkedWriterIpIdSet, onWriterToggle: onWriterToggle }))) })))));
};
exports.default = (0, mobx_react_1.observer)(SongwriterMyWritersScene);
